import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { nav } from "../actions";

const Logout = ({ logout, username }) => {
  const logoutText = ` Logout (${username})`;
  return (
    <li className="p-navigation__link">
      <button className="p-navigation__login" type="button" onClick={logout}>
        <i className="p-icon--user is-light" />
        {logoutText}
      </button>
    </li>
  );
};

Logout.displayName = "Logout";

Logout.propTypes = {
  logout: PropTypes.func.isRequired,
  username: PropTypes.string
};

Logout.defaultProps = {
  username: undefined
};

const mapDispatchToProps = {
  logout: nav.logoutStart
};

const mapStateToProps = state => ({
  username: state.user.username
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logout);
